import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

const ConfirmDialog = (props) => {
  const { title, children, open, setOpen, onConfirm } = props;

  const handleClose = (event, reason) => {
    if (reason === "backdropClick") return; // ignore backdrop clicks
    setOpen(false);
  }
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="confirm-dialog"
      sx={{
        "& .MuiDialog-container": {
        "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "500px",  // Set your width here
        },
        },
      }}
    >
      <DialogTitle id="confirm-dialog">{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button
          //variant="contained"
          onClick={handleClose}
          //color="secondary"
        >
          No
        </Button>
        <Button
          //variant="contained"
          onClick={() => {
            setOpen(false);
            onConfirm();
          }}
          //color="default"
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;